<template>
  <div class="batteryTem" style="height: 100%;">
    <p class="blockTitleP">
      <i class="el-icon-time" style="font-size: 24px;" />
      <span style="vertical-align: top;"> {{ timeAgo }}</span>
    </p>
    <!-- 锂电池--静止、充电、放电、电量低 -->
    <div class="batteryTemWarp licellTem">
      <!-- 左 -->
      <div class="batteryTemBox batteryImgAndP">
        <!-- 静止 -->
        <img v-for="(item,index) in batteryIdelImgs" v-show="item.isShow&&batteryStatusTem==0&&!socLow" :key="index" :src="item.imgUrl" style="width: 80px;">
        <!-- 充电 -->
        <img v-show="batteryStatusTem==1&&!socLow" src="@/assets/images/battery/charging.gif" style="width: 80px;">
        <!-- 放电 -->
        <img v-show="batteryStatusTem==2&&!socLow" src="@/assets/images/battery/discharging.gif" style="width: 80px;">
        <!-- 电量低 -->
        <img v-show="socLow" src="@/assets/images/battery/socLow.gif" style="width: 80px;">
        <p v-if="!socLow" style="text-align: center;margin-top: 5px;">{{ batteryStatusArr[batteryStatusTem] }}</p>
        <p v-if="socLow&&batteryCurrent==0" style="text-align: center;margin-top: 5px;">{{ batteryStatusArr[0] }}</p>
        <p v-if="socLow&&isIn&&batteryCurrent!=0" style="text-align: center;margin-top: 5px;">{{ batteryStatusArr[1] }}</p>
        <p v-if="socLow&&!isIn&&batteryCurrent!=0" style="text-align: center;margin-top: 5px;">{{ batteryStatusArr[2] }}</p>
      </div>
      <!-- 中 -->
      <!-- <div class="batteryTemBox">
        <p class="batterySoc">{{ battery.soc }}%</p>
        <p>SOC</p>
      </div> -->
      <!-- 右 -->
      <div class="batteryTemBox">
        <!-- <p class="batteryDetailP">DC SYSTEM</p> -->
        <div>
          <div class="batteryDetail">
            <div><img src="@/assets/images/battery/soc_black.png" class="batteryDetailImg"><p>{{ battery.soc }} %</p></div>
            <div><img src="@/assets/images/battery/vBlack.png" class="batteryDetailImg"><p>{{ battery.batteryVoltage }} V</p></div>
            <div><img src="@/assets/images/battery/aBlack.png" class="batteryDetailImg"><p>{{ battery.current }} A</p></div>
          </div>
          <!-- <div class="batteryDetail">
            <div><img src="@/assets/images/battery/WHcharge.png" class="batteryDetailImg"><p>{{ batteryInfo.chargingWh }} Wh</p></div>
            <div style="margin-bottom:0;"><img src="@/assets/images/battery/WHdischarge.png" class="batteryDetailImg"><p>{{ batteryInfo.usingWh }} Wh</p></div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { howLongAgo } from '@/utils/updateTime.js'
import i18n from '@/i18n'
var dRecord = {}
var dRecord2 = {}
var obj = {}
var detailSoc
export default {
  components: {
  },
  props: {
    myDeviceType: { // 设备类型 1-充电器 4-逆变器 5-锂电池
      type: String,
      default: '0'
    },
    batteryStatus: { // 电池状态 0 1 2 , // 静止，充电，放电
      type: Number,
      default: 2
    },
    batteryInfo: { // 电池状态--详细信息
      type: Object,
      default: () => {}
    },
    mcuid: {
      type: String,
      default: ''
    },
    updateTime: {
      type: Number,
      default: null
    },
    warningList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      batteryStatusArr: ['IDLE', 'CHARGING', 'DISCHARGING'], // 静止，充电，放电
      batteryStatusTem: 2,
      battery: {
        soc: 22,
        batteryVoltage: 0,
        current: 0,
        batteryTmp: 0,
        level: 0
      },
      batteryIdelImgs: [{ imgUrl: require('@/assets/images/battery/charging1.png'), isShow: false },
        { imgUrl: require('@/assets/images/battery/charging2.png'), isShow: false },
        { imgUrl: require('@/assets/images/battery/charging3.png'), isShow: false },
        { imgUrl: require('@/assets/images/battery/charging4.png'), isShow: false }
      ],
      connection: null,
      yhubmqtt: {},
      socLow: false, // 电量低
      isIn: false,
      isCharged: false,
      timeAgo: '',
      timeAgoRST: '',
      isShowLeft: true,
      timer: null,
      batteryCurrent: null
    }
  },
  computed: {
    storeYhubmqtt() {
      // console.log('------', this.$store.state.yhubmqtt)
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.timeAgo = ''; this.timeAgo = howLongAgo(this.timeAgoRST)
    },
    batteryInfo: {
      handler(newValue, oldValue) {
        this.batteryInfo = newValue // 把新值赋值给我们的属性数据
        this.queryList() // 刷新echarts图表
      },
      deep: true
    },
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        // console.log(this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        this.MQTT()
      },
      deep: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.queryList()
      // this.MQTT()
    }, 50)
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.timeAgoRST) this.timeAgo = howLongAgo(this.timeAgoRST)
        }, 60000)
      }
    },
    queryList() {
      // console.log(this.batteryStatusTem)
      console.log('batteryInfo11', this.batteryInfo)
      // console.log('warningList', this.warningList)
      if (this.warningList.indexOf(1) > -1) this.socLow = true
      this.batteryStatusTem = this.batteryStatus
      this.timeAgo = howLongAgo(this.updateTime)
      this.timeAgoRST = this.updateTime
      this.battery = JSON.parse(JSON.stringify(this.batteryInfo))
      // 经过后台查询，getLastBMSRecor返回的batteryVoltage/chargingAh/current/soc/usedAh 都放大了100倍
      if (this.battery.soc || this.battery.soc == 0) this.battery.soc = Math.round(this.battery.soc / 100)
      if (this.battery.batteryVoltage || this.battery.batteryVoltage == 0) this.battery.batteryVoltage = (this.battery.batteryVoltage / 100).toFixed(2)
      if (this.battery.current || this.battery.current == 0) this.battery.current = (this.battery.current / 100).toFixed(2)
      this.batteryIdelImgs.forEach(v => {
        v.isShow = false
      })
      if (this.battery.soc && this.battery.soc < 100 || this.battery.soc == 0 || !this.battery.soc) {
        this.batteryIdelImgs[Math.floor(this.battery.soc / 25) ].isShow = true
        if (!this.battery.soc) this.batteryIdelImgs[0].isShow = true
      } else if (this.battery.soc && this.battery.soc == 100) {
        this.batteryIdelImgs[3].isShow = true
      }
      detailSoc = this.battery.soc
      if (!this.battery.current || this.battery.current == 0) this.batteryCurrent = 0
      this.addUnit(this.battery)
    },
    MQTT() {
      if (this.yhubmqtt) {
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.mcuid) == -1) return
        // console.log('MQTT=======', this.yhubmqtt.topic)
        // console.log(this.yhubmqtt.payload)
        if (this.myDeviceType.length > 0) {
          if (this.yhubmqtt) {
            if (this.yhubmqtt.payload === 'mRealTimeData') {
              if (this.yhubmqtt && this.yhubmqtt.mRealTimeData && this.yhubmqtt.mRealTimeData.bmsRecord) {
                dRecord = this.yhubmqtt.mRealTimeData.bmsRecord
                console.log('mRealTimeData-锂电池--', dRecord)
                if (dRecord) {
                  if (dRecord.batteryVoltage == 0 || !dRecord.batteryVoltage) { return }
                  this.timeAgo = i18n.t('dataAndTime.AMomentAgo')
                  this.timeAgoRST = new Date().getTime()
                  obj = {
                    // batteryVoltage: (dRecord.batteryVoltage / 100).toFixed(2), //dRecord.batteryVoltage可能不存在
                    // current: (dRecord.current / 100).toFixed(2),
                    // soc: detailSoc,
                    updateTime: dRecord.sstamp * 1000
                  }
                  if (dRecord.soc != 0) { obj.soc = Math.round(dRecord.soc / 100) } else { obj.soc = detailSoc }
                  obj.batteryVoltage = (dRecord.batteryVoltage / 100).toFixed(2)
                  obj.current = (dRecord.current / 100).toFixed(2)
                  if (obj.current == 0 || !obj.current) {
                    this.batteryStatusTem = 0
                    this.batteryIdelImgs.forEach(v => {
                      v.isShow = false
                    })
                    // if (dRecord.soc)dRecord.soc = Math.round(dRecord.soc / 100)
                    if ((obj.soc && obj.soc < 100) || obj.soc == 0 || !obj.soc) {
                      if (!obj.soc) obj.soc = 0
                      this.batteryIdelImgs[Math.floor(obj.soc / 25) ].isShow = true
                    } else if (obj.soc && obj.soc == 100) {
                      this.batteryIdelImgs[3].isShow = true
                    }
                  } else if (obj.current < 0) { // 放电：正；充电：负
                    this.isCharged = true
                    this.batteryStatusTem = 1
                  } else {
                    this.isCharged = false
                    this.batteryStatusTem = 2
                  }
                  // obj.soc = detailSoc
                  this.addUnit(obj)
                  this.battery = obj
                }
              }
            }
          }

          this.battery.level = this.batteryInfo.level
          console.log('battery==========', this.battery)
        }
      }
    },
    addUnit(obj, name) {
      if (obj.soc != 0 && !obj.soc) obj.soc = '--'
      if (obj.batteryVoltage != 0 && !obj.batteryVoltage) obj.batteryVoltage = '--'
      if (obj.batteryTmp != 0 && !obj.batteryTmp) obj.batteryTmp = '--'
      if (obj.current != 0 && !obj.current) obj.current = '--'
    }
  }
}
</script>

<style lang="scss">
p{
  margin:0
}
.batteryTem{
  .batteryTemWarp{
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    padding: 0 5%;
  }
  .batteryTemBox{
    display: inline-block;
    // border:1px solid red;
  }
  .batteryImgAndP{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .batterySoc{
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .batteryDetailP{
    margin-bottom: 15px;
  }
  .batteryDetail{
    display: inline-block;
    margin-right: 10px;
  }
  .batteryDetail div{
    margin-bottom: 10px;
  }
  .batteryDetail p{
    line-height: 30px;
    display: inline-block;
    vertical-align: top;
  }
  .licellTem {
    .batteryDetail p {
      line-height: 30px;
      display: inline-block;
      vertical-align: top;
      font-size: 16px;
      // font-weight: bold;
    }
    .batteryDetail .batteryDetailImg {
      width: 30px;
      margin-right: 5px;
      margin-top: 0px;
    }
  }
  .warningWrap{
    padding:70px 0;
    font-size: 14px;
    display: flex;
    // justify-content: space-between;
    justify-content: space-around;
    text-align: center;
    overflow-y: auto;
  }
  .warningDivs{
    display: inline-block;
  }
  .popWarp{
    position: relative;
    z-index: 2001;
    background: white;
    padding: 10px 20px 0;
    border:1px solid #e5e5e5;
    box-shadow: 4px 4px 2px #ccc;
    min-width: 500px;
  }
}
</style>

